import { useContext } from 'react';
//
import { AuthContext } from '../contexts/JWTContext';
import { JWTContextType } from '../@types/auth';
// import { AuthContext } from '../contexts/Auth0Context';
// import { AuthContext } from '../contexts/FirebaseContext';
// import { AuthContext } from '../contexts/AwsCognitoContext';

// ----------------------------------------------------------------------

const DEVICE_ID_STORAGE_KEY = 'mfa-device-id';

type UseAuthWithDevice = JWTContextType & {
  deviceId: string | null;
  getSessionDeviceId: () => string | null;
};

const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) throw new Error('Auth context must be use inside AuthProvider');

  const getSessionDeviceId = () => {
    if (typeof window === 'undefined') return null;
    return window.sessionStorage.getItem(DEVICE_ID_STORAGE_KEY);
  };

  return {
    ...context,
    deviceId: getSessionDeviceId(),
    getSessionDeviceId,
  } as UseAuthWithDevice;
};

export default useAuth;
